import { Component, NgZone } from "@angular/core";
import "reflect-metadata";
import { Title } from "@angular/platform-browser";

import { Platform } from "@ionic/angular";

import { Capacitor } from "@capacitor/core";
//import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";

import { TranslateService } from "@ngx-translate/core";

import { environment } from "@env/environment";

import { AuthService } from "@services/auth.service";
import { DefinitionsService } from "@state/definitions/definitions.service";
import { FirmwareService } from "@shared/state/firmware/firmware.service";
import { ProvisioningService } from "@shared/services/provisioning.service"; // for key handeling
import { NativeTestService } from "@shared/services/native-test.service";

import { App, URLOpenListenerEvent } from "@capacitor/app";
import { Router } from "@angular/router";

import { getFirestore, doc, getDoc } from "firebase/firestore";

import { compareVersions } from "compare-versions";
import { AppInfoStore } from "@shared/store/app-info";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  public env = environment.environment;

  public isProduction = environment.production;

  constructor(
    private platform: Platform,
   
    private statusBar: StatusBar,
    private authService: AuthService,
    private screenOrientation: ScreenOrientation,
    translateService: TranslateService,
    titleService: Title,
    private definitionsService: DefinitionsService,
    private firmwareService: FirmwareService,
    private router: Router,
    private zone: NgZone,
    private prov: ProvisioningService,
    private nativeTest: NativeTestService,
  ) {
    App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        // Example url: https://beerswift.app/tabs/tab2
        // slug = /tabs/tab2
        const slug = event.url.split(".com").pop();
        if (slug) {
          this.router.navigateByUrl(slug);
        }
      });
    });
    // this.splashScreen.show();
    this.initializeApp();

    translateService.setDefaultLang("en");
    const curLang = translateService.getBrowserLang();
    if (curLang?.includes("sv")) {
      translateService.use("sv");
    } else {
      translateService.use("en");
    }

    const title = environment.production ? "" : environment.environment + "-";
    titleService.setTitle(title + "Rototilt Connect");
  }

  private initializeApp(): void {
    this.platform.ready().then(() => {
      /*  if (this.platform.is("capacitor")) {
        // Enable firebase Crashlytics
        // Lock orientation on android/ios
        const orientation = this.screenOrientation.ORIENTATIONS.PORTRAIT;
        this.screenOrientation.lock(orientation);

        this.enforceUpdateIfNeeded();
        // console.log('currentVersion =');
      }*/
      const isNative = Capacitor.isNativePlatform();
      const isAndroid = Capacitor.getPlatform() === "android";
      const isIos = Capacitor.getPlatform() === "ios";

     

      if (isNative) {
        const orientation = this.screenOrientation.ORIENTATIONS.PORTRAIT;
        this.screenOrientation.lock(orientation);

        this.enforceUpdateIfNeeded();
      }

      // this.nativeTest.testPlugin();
      this.prov.provisionIfNeeded();

      this.definitionsService.loadDefinitions();
      this.firmwareService.loadFirmwares();

      if (isNative) {
        this.statusBar.styleDefault();
      }
      // this.splashScreen.hide();
     /* setTimeout(() => {
         SplashScreen.hide();
      }, 5000);*/
      this.authService.onAuthStateChanged();
    });
  }

  async enforceUpdateIfNeeded() {
    const info = await App.getInfo();

    AppInfoStore.version = info.version;
    AppInfoStore.build = info.build;
    AppInfoStore.name = info.name;

    //App.getInfo().then((info) => alert('Current version: ' + info.version));
    const currentVersion = AppInfoStore.version;

    //console.log('currentVersion =', currentVersion);

    // for testing use  app_version_test;
    // for release use app_versions

    const db = getFirestore();
    const configDoc = await getDoc(doc(db, "config", "app_versions"));
    // console.log(configDoc);
    const data = configDoc.data();

    const requiredVersion = this.platform.is("android")
      ? data?.min_version_android
      : data?.min_version_ios;

    if (
      requiredVersion &&
      compareVersions(currentVersion, requiredVersion) < 0
    ) {
      this.router.navigateByUrl("/force-update", { replaceUrl: true });
    }
  }
}
